
export function getUid() {
  return sessionStorage.getItem('uid') || localStorage.getItem('uid')
}
export function hostIp() {
  return localStorage.getItem('hostIp') || ''
}

export function getUserPhone() {
  return sessionStorage.getItem('currentUserPhone') || localStorage.getItem('currentUserPhone')
}

export function setIsHouseKeeper(isHouseKeeper) {
  localStorage.setItem('isHouseKeeper', isHouseKeeper)
}

// 是否老板
export function setIsCeo(isCeo) {
  localStorage.setItem('isCeo', isCeo)
}

export function setIsShopOwner(isShopOwner) {
  localStorage.setItem('SHOPOWNER', isShopOwner)
}

// 是否店长
export function isShopOwner() {
  return JSON.parse(sessionStorage.getItem('SHOPOWNER') || localStorage.getItem('SHOPOWNER'))
}

// 是否小管家
export function isHouseKeeper() {
  return JSON.parse(sessionStorage.getItem('isHouseKeeper') || localStorage.getItem('isHouseKeeper'))
}

export function setIsHouseKeeperManager(isHouseKeeperManager) {
  localStorage.setItem('isHouseKeeperManager', isHouseKeeperManager)
}

// 是否公寓事业部经理
export function isHouseKeeperManager() {
  return JSON.parse(sessionStorage.getItem('isHouseKeeperManager') || localStorage.getItem('isHouseKeeperManager'))
}

export function setIsHouseKeeperApartment(isHouseKeeperApartment) {
  localStorage.setItem('isHouseKeeperApartment', isHouseKeeperApartment)
}

// 是否片区负责人
export function isHouseKeeperApartment() {
  return JSON.parse(sessionStorage.getItem('isHouseKeeperApartment') || localStorage.getItem('isHouseKeeperApartment'))
}

export function setIsOpenManager(isOpenManager) {
  localStorage.setItem('isOpenManager', isOpenManager)
}

// 是否运营部经理
export function isOpenManager() {
  return JSON.parse(sessionStorage.getItem('isOpenManager') || localStorage.getItem('isOpenManager'))
}

export function setIsOpenExecutive(isOpenExecutive) {
  localStorage.setItem('isOpenExecutive', isOpenExecutive)
}

// 是否运营主管
export function isOpenExecutive() {
  return JSON.parse(sessionStorage.getItem('isOpenExecutive') || localStorage.getItem('isOpenExecutive'))
}

export function setIsOpenProfessional(isOpenProfessional) {
  localStorage.setItem('isOpenProfessional', isOpenProfessional)
}

// 是否运营专员
export function isOpenProfessional() {
  return JSON.parse(sessionStorage.getItem('isOpenProfessional') || localStorage.getItem('isOpenProfessional'))
}

export function setIsNuvotonmcu(isNuvotonmcu) {
  localStorage.setItem('isNuvotonmcu', isNuvotonmcu)
}

// 是否销售专员
export function isNuvotonmcu() {
  return JSON.parse(sessionStorage.getItem('isNuvotonmcu') || localStorage.getItem('isNuvotonmcu'))
}

export function setIsNuvotonmcuManager(isNuvotonmcuManager) {
  localStorage.setItem('isNuvotonmcuManager', isNuvotonmcuManager)
}

// 是否销售主管
export function isNuvotonmcuManager() {
  return JSON.parse(sessionStorage.getItem('isNuvotonmcuManager') || localStorage.getItem('isNuvotonmcuManager'))
}

export function setIsMarketingManager(isMarketingManager) {
  localStorage.setItem('isMarketingManager', isMarketingManager)
}

// 营销部经理
export function isMarketingManager() {
  return JSON.parse(sessionStorage.getItem('isMarketingManager') || localStorage.getItem('isMarketingManager'))
}

export default {
  getUid,
  hostIp,
  getUserPhone,
  setIsHouseKeeper,
  isHouseKeeper,
  setIsHouseKeeperManager,
  isHouseKeeperManager,
  setIsHouseKeeperApartment,
  isHouseKeeperApartment,
  setIsOpenManager,
  isOpenManager,
  setIsOpenExecutive,
  isOpenExecutive,
  setIsOpenProfessional,
  isOpenProfessional,
  setIsNuvotonmcu,
  isNuvotonmcu,
  setIsNuvotonmcuManager,
  isNuvotonmcuManager,
  setIsMarketingManager,
  setIsCeo,
  isMarketingManager,
  setIsShopOwner,
  isShopOwner
}



// WEBPACK FOOTER //
// ./src/lib/role.js